import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-control-rate-landing-page',
  templateUrl: './project-control-rate-landing-page.component.html',
  styleUrls: ['./project-control-rate-landing-page.component.scss']
})
export class ProjectControlRateLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
